import { NgModule } from '@angular/core';

import { ReactivateSubscriptionComponent } from './subscription.reactivate.component';
import { SharedModule }                    from '../shared/shared.module';
import { SubscriptionService }             from './subscription.service';

@NgModule({
  declarations: [
    ReactivateSubscriptionComponent
  ],
  entryComponents: [
    ReactivateSubscriptionComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    SubscriptionService
  ]
})
export class SubscriptionsModule {}
